module.exports = __webpack_public_path__ + "img/ae.24dc5ba9.svg";